import { createSelector } from '@reduxjs/toolkit';

import {
  DataSourceType,
  SAMPLE_MUSIC_DATA_SOURCE_TYPE,
  SAMPLE_MUSIC_DATA_SOURCE_TYPE_LABEL,
  UNKNOWN_DATA_SOURCE_TYPE,
  UNKNOWN_DATA_SOURCE_TYPE_LABEL,
} from 'src/constants/dataSourceTypeDescription';
import { dataSourceTypesSelector } from 'src/selectors/dataSourceTypes';
import { Connection } from 'src/store/connections/types';

export const dataSourceLabelsByTypeSelector = (connection: Connection | null) =>
  createSelector(
    dataSourceTypesSelector(connection),
    (dataSourceTypes): Record<DataSourceType, string> =>
      Object.entries(dataSourceTypes).reduce(
        (agg, [dataSourceType, { label }]) => ({
          ...agg,
          [dataSourceType]: label || UNKNOWN_DATA_SOURCE_TYPE_LABEL,
        }),
        {
          [SAMPLE_MUSIC_DATA_SOURCE_TYPE]: SAMPLE_MUSIC_DATA_SOURCE_TYPE_LABEL,
          [UNKNOWN_DATA_SOURCE_TYPE]: UNKNOWN_DATA_SOURCE_TYPE_LABEL,
        }
      )
  );
